import { render, staticRenderFns } from "./CustomProperties.vue?vue&type=template&id=d041094c&scoped=true&"
import script from "./CustomProperties.vue?vue&type=script&lang=js&"
export * from "./CustomProperties.vue?vue&type=script&lang=js&"
import style0 from "./CustomProperties.vue?vue&type=style&index=0&id=d041094c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d041094c",
  null
  
)

export default component.exports